import {
	addGroupCategory,
	deleteGroupCategory,
	renameGroupCategory,
} from '@front-app/services/GroupsApi/GroupsCategoriesApi';
import { GroupsStore } from './groups';

export interface GroupCategoriesStore {
	renameCategory(groupId: string, existingCategory: string, newCategoryName: string): Promise<void>;
	deleteCategory(groupId: string, category: string): Promise<void>;
	addCategory(groupId: string, category: string): Promise<void>;
}

export const getGroupCategoriesStore = (groupsStore: GroupsStore): GroupCategoriesStore => {
	const renameCategory = async (groupId: string, existingCategory: string, newCategoryName: string) => {
		const categories = await renameGroupCategory(groupId, existingCategory, newCategoryName);
		groupsStore.updateLocalGroup(groupId, { categories });
	};
	const deleteCategory = async (groupId: string, category: string) => {
		const categories = await deleteGroupCategory(groupId, category);
		groupsStore.updateLocalGroup(groupId, { categories });
	};
	const addCategory = async (groupId: string, category: string) => {
		const categories = await addGroupCategory(groupId, category);
		groupsStore.updateLocalGroup(groupId, { categories });
	};
	return {
		renameCategory,
		deleteCategory,
		addCategory,
	};
};
